import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
// import BloomLogo from "../assets/logo-bloom.svg"

import settingsIcon from "../assets/Setting.svg";

const TopNavBar = ({ isCallActive = false }) => {
  const [title, setTitle] = useState("Bloom");
  const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    const storedTitle = localStorage.getItem("organization_name");
    if (storedTitle) {
      setTitle(storedTitle);
    }
  }, []);

  const handleProfileClick = () => {
    navigate("/admin"); // Redirect to /admin
  };

  return (
    <nav className="flex items-center justify-between px-4 md:px-6 py-2 md:py-3 bg-white shadow-sm">
      {/* Organization name */}
      <div className="flex items-center">
        <span className="text-2xl font-bold  text-gray-800">{title}</span>
      </div>

      {/* Profile Section */}
      <div className="md:flex items-center">
        <button 
          onClick={handleProfileClick}
          disabled={isCallActive} // Disable button when call is active
          className={`${isCallActive ? 'opacity-50 cursor-not-allowed' : ''}`}
        >
          <img
            src={settingsIcon}
            alt="Profile"
            className="h-8 w-8 md:h-10 md:w-10 rounded-full object-cover cursor-pointer"
          />
        </button>
      </div>
    </nav>
  );
};

export default TopNavBar;
